module.exports = __webpack_public_path__ + "img/DSC00219.6c1bc2d0.JPG";